'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BuyerAssuranceIcon from 'dibs-vg/dist/react/buyer-assurance';
import styles from './styles/Benefits.scss';

import copy from '../../../../../json/copy/pdp.json';

function Benefit({item}) {
    return (
        <div className={styles.benefit}>
            <div className={styles.icon}>
                <BuyerAssuranceIcon />
            </div>
            <div className={styles.text}>
                {item.title}
            </div>
        </div>
    );
}

Benefit.propTypes = {
    item: PropTypes.object
};

class Benefits extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hasAnimation: true
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.timeoutAnimation();
        }, 1000);
    }

    timeoutAnimation() {
        this.setState({ hasAnimation: false });
    }

    render() {
        const { title, linkText, linkUrl, fields } = copy.benefits;
        const benefitsClass = classNames(styles.benefits, {
            [styles.hasAnimation]: this.state.hasAnimation
        });

        return (
            <div className={benefitsClass}>
                <div className={styles.title}>{title}</div>
                {fields.map((item, index) => {
                    return <Benefit item={item} key={index} />;
                })}
                <a href={linkUrl} target="_blank" title={linkText}>{linkText}</a>
            </div>
        );
    }
}

module.exports = Benefits;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Sidebar/Benefits.jsx